import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'report-homes-assistants',
  templateUrl: './homes-assistants.component.html',
  styleUrls: ['./homes-assistants.component.scss'],
})
export class HomesAssistantsComponent implements OnInit {
  @Input() items: any[];

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onHomeDetail(home) {
    home.email = 'By report';
    home.macAddress = '';
    localStorage.setItem('home_det', JSON.stringify(home));
    this.router.navigate(['/homes/detail']);
  }
}
